import React from 'react';
import { ModalSliceType, openModal } from '../../../redux/slices/modal';
import { RowType } from '../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../redux/hooks';
import usePermission from '../../../utils/hooks/permissionHooks';
import {
  ICohortFieldsFragment,
  PermissionKey,
} from '../../../utils/apollo/graphqlSchema';
import { SecondaryButton } from '../../Button';
import {
  cohortCompareTooltipOption,
  cohortSampleTooltipOption,
} from '../../KubitTooltip/globalTooltips';
import PermissionElementWrapper from '../../../pages/PermissionControls/PermissionElementWrapper';
import KubitTooltip from '../../KubitTooltip';

interface IProps {
  analysisId: string;
  schemaId: string;
  cohortBuilderInfo: ICohortFieldsFragment;
  isCompareOperation: boolean;
}

const CohortSampleChartSaveCohortAction = ({
  analysisId,
  schemaId,
  cohortBuilderInfo,
  isCompareOperation,
}: IProps) => {
  const dispatch = useAppDispatch();

  const { checkIsPermitted } = usePermission();
  const isPermittedToCreateUpdateCohort = checkIsPermitted({
    requiredPermissionKeys: [
      PermissionKey.CohortCreate,
      PermissionKey.CohortEdit,
    ],
    schemaId,
    validateKind: 'OR',
  });

  const onClickSaveCohort = () => {
    dispatch(
      openModal({
        type: ModalSliceType.SaveCohortFromAnalysisId,
        id: analysisId,
        data: {
          rowMeta: {
            rowType: RowType.builderCohorts,
            rowIndex: 0,
          },
          cohortBuilderInfo,
        },
      }),
    );
  };

  if (isCompareOperation) {
    return (
      <KubitTooltip {...cohortCompareTooltipOption} placement="bottom">
        {/* Save Intersection save compare compound cohort as AND operator */}
        <SecondaryButton
          type="button"
          onClick={onClickSaveCohort}
          isOutlined
          trackContext="cohorts"
          trackAction="save intersection"
        >
          Save Intersection
        </SecondaryButton>
      </KubitTooltip>
    );
  }

  return (
    <PermissionElementWrapper isPermitted={isPermittedToCreateUpdateCohort}>
      <KubitTooltip
        {...cohortSampleTooltipOption}
        disabled={!isPermittedToCreateUpdateCohort}
        placement="bottom"
      >
        <SecondaryButton
          type="button"
          onClick={onClickSaveCohort}
          isOutlined
          disabled={!isPermittedToCreateUpdateCohort}
          trackContext="cohorts"
          trackAction="save cohort"
        >
          Save Cohort
        </SecondaryButton>
      </KubitTooltip>
    </PermissionElementWrapper>
  );
};

export default CohortSampleChartSaveCohortAction;
